$(() => {
  $('[data-submit-on-change]').on('change', function() {
    $(this)
      .closest('form')
      .submit();
  });
});
